
import {
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { ReactNode } from 'react';



export type BaseCustomChartLayoutProps = {
  title?: string;
  children: ReactNode | ReactNode[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: BaseCustomChartLayoutProps) => {

  const theme = useTheme();
  return (
    <Box
      // flex = '1 1 0'

      display='flex'
      flexDirection='column'
      borderRadius='1rem'
      border={`1px solid ${theme.palette.gray.light20}`}
      minHeight='400px'
      paddingTop='1rem'
      paddingRight='1rem'

      sx={{
        background: `repeating-linear-gradient(35deg,
          ${theme.palette.gray.light05} 8px,
          ${theme.palette.gray.light10} 11px,
          ${theme.palette.gray.light20} 12px,
          ${theme.palette.gray.light10} 13px
        )`
      }}
    >
      <Stack
        direction='row'
        paddingLeft='1rem'
        paddingBottom='.75rem'
      >
        <Typography variant='chartTitle'>{props.title ?? 'Title'}</Typography>
      </Stack>
      <Box
        flex='1 1 0'
      >
        {props.children}
      </Box>
      {/* <Stack direction = 'row' paddingX = '1rem' paddingBottom = '1rem'>
        {props?.children}
      </Stack> */}
    </Box>
  );
};
